<div class="modal-header">
    <h4 class="modal-title" id="modal-title">Cambiar inspector</h4>
    <button
      type="button"
      class="close"
      aria-label="Close button"
      aria-describedby="modal-title"
      [disabled]="loading"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
</div>
  
<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="modal-body">
      <p>
        <strong>
          ¿Estás seguro de que deseas modificar la asignación de inspectores del expediente
          <span class="text-primary">"{{ code }}"</span>?
        </strong>
      </p>
      
      <div class="form-group">
        <label class="form-check m-0" ngbButtonLabel>
          <input
            type="checkbox"
            formControlName="onlyOneInspector"
            ngbButton
          />
          Solo un inspector
        </label>
      </div>

      <div formArrayName="inspectors">
        <div
          *ngFor="let group of getFormArrayInspectors.controls; let i = index"
          [formGroupName]="i"
        >
          <div class="form-group">
            <label>
              Asignar Inspector{{ getFormArrayInspectors.length > 1 ? ' ' + (i + 1) + ' y alcances' : '' }}<span class="text-danger">*</span>
            </label>

            <div
              [ngStyle]="{
                display: 'grid',
                'grid-template-columns': form.get('onlyOneInspector')?.value ? '1fr' : 'repeat(2, minmax(0, 1fr))',
                gap: '1rem'
              }"
            >
              <div>
                <select
                  formControlName="inspector"
                  class="form-control"
                >
                  <option [ngValue]="null">
                    Seleccione un inspector
                  </option>

                  <option
                    *ngFor="let inspector of data.inspectors"
                    [ngValue]="inspector.id"
                    [disabled]="isInspectorSelected(inspector.id, i)"
                  >
                    {{ inspector.name }}
                  </option>
                </select>

                <div *ngIf="getInspectorControl(i)?.touched && getInspectorControl(i)?.invalid">
                  <small 
                    class="text-danger"
                    *ngIf="getInspectorControl(i)?.getError('required') || getInspectorControl(i)?.hasError('required')"
                  >
                    Inspector requerido
                  </small>
                </div>
              </div>

              <div>
                <ng-select
                  *ngIf="!form.get('onlyOneInspector')?.value"
                  placeholder="Seleccione los alcances"
                  [items]="scopeOptionsView"
                  bindLabel="name"
                  bindValue="value"
                  [multiple]="true"
                  [searchable]="false"
                  [clearable]="false"
                  formControlName="scopesInspector"
                  (add)="addedScope($event)"
                  (remove)="removedScope($event)"
                >
                </ng-select>

                <div *ngIf="getScopesControl(i)?.touched">
                  <small 
                    class="text-danger"
                    *ngIf="getScopesControl(i)?.getError('required') || getInspectorControl(i)?.hasError('required')"
                  >
                    Alcances requeridos
                  </small>

                  <small 
                    class="text-danger"
                    *ngIf="getScopesControl(i)?.getError('duplicateScope')"
                  >
                    Hay alcances duplicados en otro inspector
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button
        [disabled]="loading"
        type="button"
        class="btn btn-outline-secondary"
        (click)="modal.dismiss('cancel click')"
      >
        Cancelar
      </button>

      <button
        [disabled]="loading"
        type="button"
        ngbAutofocus
        class="btn btn-primary"
        (click)="onSubmit()"
      >
        <span
          *ngIf="loading"
          class="spinner-border spinner-border-sm mr-1"
        ></span>
        Aceptar
      </button>
    </div>
</form>
  